<template>
  <div v-title="$route.meta.title"
       v-loading="loading">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>实习生管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="'/audit-intern/attendance-plan-monthly'">考勤计划月度列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="实习生账号"
                        prop="intern_user_id">
            <remote-select class="width-max"
                           v-model="search.intern_user_id"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           keyword-key="name"
                           placeholder="请输入账号名搜索"
                           :query-request="queryInternTableApi"
                           :find-request="getInternBaseInfoApi">
            </remote-select>
          </el-form-item>
          <el-form-item label="计划月份"
                        prop="plan_month">
            <el-date-picker v-model="search.plan_month"
                            class="width-max"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="请选择计划月份"
                            clearable>
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportPlanDates()">
            按条件导出出勤明细
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border>
        <el-table-column prop="id"
                         label="ID"
                         width="100">
        </el-table-column>
        <el-table-column prop="intern_user_id"
                         label="账号ID"
                         min-width="90">
        </el-table-column>
        <el-table-column prop="intern_name"
                         label="账号"
                         min-width="140">
        </el-table-column>
        <el-table-column prop="plan_month"
                         label="出勤月份"
                         min-width="100">
        </el-table-column>
        <el-table-column prop="plan_date"
                         label="出勤日期"
                         min-width="120">
        </el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"
                         min-width="160">
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total"
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange">
        </el-pagination>
      </div>
    </layout-panel>

    <div class="margin t15">
      <el-button icon="el-icon-back"
                 @click="$router.push('/audit-intern/attendance-plan-monthly')">返回列表
      </el-button>
    </div>
  </div>
</template>

<script>
import RemoteSelect from '@core/components/RemoteSelect.vue'
import table from '@core/mixins/table-v3'
const emptyDetail = () => ({
  intern_user_id: '',
  intern_name: '',
  plan_month: '',
  planned_days: 0,
  plan_dates: [],
})

const exportHeader = [
  {key: 'id', text: 'ID'},
  {key: 'intern_user_id', text: '账号ID'},
  {key: 'intern_name', text: '账号'},
  {key: 'plan_month', text: '出勤月份'},
  {key: 'plan_date', text: '出勤日期'},
  {key: 'updated_at', text: '更新时间'},
]

export default {
  mixins: [table],
  components: {RemoteSelect},
  data () {
    return {
      detail: emptyDetail(),
      search: {
        intern_user_id: null,
        plan_month: null,
      },
      searchFieldType: {
        intern_user_id: Number,
      },
      loading: false,
      isLoadTableInBeforeRouteEnter: false,
      isLoadTableInBeforeRouteUpdate: false,
    }
  },
  watch: {
    '$route.params': {
      handler () {
        this.setSearchFromRoute()
        this.setPagination({current_page: 1})
        this.loadDetail({current_page: 1})
      },
      deep: true,
    },
  },
  created () {
    this.setSearchFromRoute()
    this.loadDetail({current_page: 1})
  },
  methods: {
    ...request.map(['queryInternTableApi', 'getInternBaseInfoApi']),
    setSearchFromRoute () {
      this.search.intern_user_id = this.$route.params.internUserId
        ? Number(this.$route.params.internUserId)
        : null
      this.search.plan_month = this.$route.params.planMonth || null
    },
    getTableData (params) {
      this.loading = true
      const query = {
        intern_user_id: params.intern_user_id,
        plan_month: params.plan_month,
      }
      return request.page('getInternAttendancePlanMonthlyDetailApi', query).finally(() => {
        this.loading = false
      })
    },
    setTableData ({data}) {
      const detail = data || emptyDetail()
      const rows = (detail.plan_dates || []).map(row => ({
        ...row,
        intern_user_id: detail.intern_user_id,
        intern_name: detail.intern_name,
        plan_month: detail.plan_month,
      }))
      const currentPage = Number(this.lastSearchParams.current_page) || 1
      const perPage = Number(this.lastSearchParams.per_page) || this.pagination.per_page
      const start = (currentPage - 1) * perPage

      this.detail = detail
      this.$set(this, 'table', rows.slice(start, start + perPage))
      this.setPagination({
        current_page: currentPage,
        per_page: perPage,
        total: rows.length,
      })
    },
    loadDetail (pagination = {}) {
      const params = {
        ...this.search,
        ...pagination,
        current_page: pagination.current_page || this.pagination.current_page,
        per_page: pagination.per_page || this.pagination.per_page,
      }
      this.lastSearchParams = params
      return this.getTableData(params).then(this.setTableData)
    },
    onSearch () {
      this.setPagination({current_page: 1})
      return this.loadDetail({current_page: 1})
    },
    onRefresh () {
      return this.loadDetail(this.lastSearchParams)
    },
    handleSizePageChange (size) {
      this.setPagination({current_page: 1, per_page: size})
      return this.loadDetail({current_page: 1, per_page: size})
    },
    handleCurrentPageChange (page) {
      this.setPagination({current_page: page})
      return this.loadDetail({current_page: page})
    },
    onExportPlanDates () {
      const rows = this.detail.plan_dates.map(row => ({
        ...row,
        intern_user_id: this.detail.intern_user_id,
        intern_name: this.detail.intern_name,
        plan_month: this.detail.plan_month,
      }))
      this.$export('导出实习生考勤计划明细', rows, {fileHeader: exportHeader})
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/audit-intern/pages/InternAttendancePlanDetail.vue